import httpConfig from "./config";

export default {
  async getUser(cb) {
    // run axios setup
    let http = httpConfig();

    // Get the current user from the backend
    await http
      .get("/api/Users/GetUserRoles")
      .then(function(response) {
        let userObject = response.data;

        // Parse backend information into a user object
        let user = {
          id: "",
          userId: userObject.asuriteId,
          userRoles: [],
          isImpersonating: userObject.isImpersonating,
          trueUser: userObject.trueUser
            ? userObject.trueUser
            : userObject.asuriteId,
          firstName: userObject.firstName,
          lastName: userObject.lastName,
          email: userObject.email,
          xsrftoken: userObject.xsrftoken
        };

        // Iterate through received roles and add their names to the user's userRoles array
        for (var index in userObject.roles) {
          user.userRoles.push(userObject.roles[index].name);
        }

        cb(user);
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};
